import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import { Link } from "react-router-dom";
import ElectD from "../../assets/ElectricalDiag.png";

const ElectricalDiagnostics = () => {
  return (
    <>
      <SeoHead
        title="Electrical Diagnostics in Temecula | Advanced Automotive Smog"
        description="Electrical diagnostics for wiring, sensor, and control-module issues in Temecula. We pinpoint the cause of warning lights and electrical faults before repair."
        path="/services/electrical-diagnostics"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Electrical & Diagnostics"
          path="/services/electrical-diagnostics"
          description="Electrical diagnostics for wiring, sensor, and control-module issues in Temecula."
          serviceType="Electrical diagnostics"
        />
        
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={ElectD}
                alt="Electrical diagnostics service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Electrical & Diagnostics
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Electrical & Diagnostics
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Flickering lights, warning messages, or electronics acting up?
              Our electrical diagnostics pinpoint the issue so we can fix it
              quickly and get all your systems working the way they should.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Electrical Diagnostics?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Modern vehicles rely on complex wiring, sensors, computers, and
              control modules. When something goes wrong, you need more than a
              guess—you need accurate diagnostics.
              <br />
              <br />
              We use advanced scan tools and testing equipment to trace
              electrical faults, then repair or replace the components causing
              the problem.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Computer and sensor diagnostics for all systems</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Testing and repair of wiring, fuses, and connections</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>
                  Resolution of{" "}
                  <Link to="/check-engine-light" className="text-teal-600 hover:underline">
                    warning lights
                  </Link>{" "}
                  and dashboard errors
                </span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Service for all makes, models, and electrical systems</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps prevent recurring electrical problems</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default ElectricalDiagnostics;

